<template>
    <div class="w-full min-h-[60vh] largeDesktop:min-h-[80vh]">
        <div
            class="myHappyHomeLandingPage relative border-1 rounded-[20px] min-w-full p-[5px] laptop:p-[15px] bg-opacity-50 bg-[#fff] border-[#CCCCCC]">
            <div class="shadow-[0px_0px_10px_0px_#00000026] rounded-[20px] p-[15px] tablet:p-[20px] bg-[#fff]">
                <h2 class="mb-[20px] text-[18px] tablet:text-[22px] font-days text-[#2459A8]">Saved Payment Methods</h2>
                <div>
                    <div>
                        <paymentMethodCard @event="defauleCardCallBack" ref="paymentMethodCardRefs" />
                    </div>
                    <div class="pt-[20px] mt-[20px] border-t border-[#CCCCCC]">
                        <paymentMethodForm ref="paymentMethodFormRefs" :stripe_id="stripId" @submit-detail="addCard" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
import { mapActions, mapGetters } from "vuex";
import paymentMethodCard from '../../components/nest_components/payment-method-card.vue';
import paymentMethodForm from '../../components/nest_components/payment-method-form.vue';
export default {
    components: {
        paymentMethodCard,
        paymentMethodForm
    },
    data() {
        return {
            stripId: null,
            cardId: null,
            isPaymentApiCall : false
        }
    },
    computed: {
        ...mapGetters([
            "addCreditCardResponse", "failedInvoices", "paymentCollectResponse", "paymentCollectFailResponse"
        ]),
    },
    watch: {


        paymentCollectFailResponse: function (data) {
            if (this.paymentCollectFailResponse.length > 0) {
                this.onPaymentFail(this.paymentCollectFailResponse)
            }
        },
        paymentCollectResponse: function (data) {
            this.onPaymentSuccess(this.paymentCollectResponse)
        },

        addCreditCardResponse: function (data) {

            this.$refs.paymentMethodFormRefs.reset()
            this.$refs.paymentMethodCardRefs.getCardListing()
            this.cardId = this.addCreditCardResponse.card_id

            this.isPaymentApiCall = true

            this.getFailedInvoices({

            })
        },

        failedInvoices: function (data) {

            if(!this.isPaymentApiCall) return

            this.isPaymentApiCall = false
            let invoices = this.failedInvoices.invoices.map(invoice => invoice.invoice_id)
            if (this.failedInvoices.invoices.length > 0) {

                const message = `
                      <p class="text-[16px]">
                            There are outstanding invoice(s) totaling&nbsp;<strong>${this.failedInvoices.total_amount_formatted}</strong>.
                           <br><br>
                              Would you like to charge this card to pay the outstanding balance?
                      </p>`;
                // const message = `There are outstanding invoice(s) totaling ${this.failedInvoices.total_amount_formatted}. \n \n Would you like to charge this card to pay the outstanding balance?`;
                this.$dialog.show({
                    title: "Outstanding Invoice(s)",
                    html: message,
                    onConfirm: () => {
                        this.paymentCollect({
                            card_id: this.cardId,
                            invoice_ids: invoices
                        })
                    },
                });

            }

        },

    },

    methods: {

        ...mapActions([
            "addCreditCard",
            "getFailedInvoices",
            "paymentCollect"
        ]),

        defauleCardCallBack(cId) {
            this.cardId = cId
            this.isPaymentApiCall = true
            this.getFailedInvoices({})
        },
        onPaymentFail(data) {
            //temp dialogue
            this.$dialog.show({
                title: "Payment Failed",
                buttonText: "Dimiss",
                showCross: false,
                html: `
                        <div class="flex flex-col items-center justify-center gap-4 text-gray-700 text-[16px]">
                            <img src=${require('../../assets/images/caution-icon.png')} style="width:60px; height:auto;">
                          <p style="word-break: break-word;" class="text-[14px] m-0"> ${data}</p>
                        </div>`,
                onConfirm: () => {

                },
            });
        },

        onPaymentSuccess(data) {
            //temp dialogue
            this.$dialog.show({
                title: "Payment Successful",
                buttonText: "View Invoice",
                html: `
                    <div class="rounded-lg border border-gray-200 bg-white p-[10px]">
                        <p class="mb-[10px] text-[14px] text-gray-800">
                            Your payment of <span class="font-semibold">${data.total_charged_formatted}</span> has been processed successfully.
                        </p>

                        <div class="space-y-2 text-gray-700 text-left">
                            <p>
                            <span class="text-[12px] font-bold">Invoice Number:</span>
                            <span class="text-[12px] ml-1">${data.stripe_invoice_number}</span>
                            </p>
                        </div>
                    </div>`,
                onConfirm: () => {

                    window.open(data.stripe_invoice_url, '_blank');
                },
            });
        },

        addCard(obj) {
            this.addCreditCard({
                card_token: obj.card_token,
                card_holder_name: obj.card_holder_name,
                is_default: obj.is_default
            })
        }
    },
}
</script>